import store from "../store";
import { ClearBetStore } from "./betAction";
import { ClearSportsList } from "./sportsAction";
import {
  SET_PAGE_DATA,
  SET_PAGE_INFO,
  SET_PAGE_LOAD,
  SET_PER_PAGE,
  SET_CHECK_PAGE,
  SET_MESSAGE_PAGE,
  SET_GAMECHECK,
  SET_RECONNECT_SETTING,
  SET_SCROLL_DIRECTION,
} from "./types";

export const SetPageInfo = (data) => (dispatch) => {
  let nowData = store.getState().page.pageInfo;
  // //console.log(nowData);
  // //console.log(data);
  // //console.log( nowData.sportType === data.sportType, nowData.gameType === data.gameType,  )
  // ( nowData.pageType !== "virtual" && nowData.pageType !== "virtual" ) && (nowData.sportType !== data.sportType || nowData.gameType !== data.gameType)
  if (
    nowData.sportType !== data.sportType ||
    nowData.gameType !== data.gameType
  ) {
    dispatch(ClearSportsList());
    dispatch(ClearBetStore());
  }

  dispatch({
    type: SET_PAGE_INFO,
    payload: data,
  });
};

export const SetPageLoading = (data) => (dispatch) => {
  dispatch({
    type: SET_PAGE_LOAD,
    payload: data,
  });
};

export const SetCurrentPage =
  (data = { page: 1, totalPage: 1 }) =>
  (dispatch) => {
    // console.log("-----------------------------",data)
    dispatch({
      type: SET_PAGE_DATA,
      payload: data,
    });
  };

export const SetScrollDirection =
  (data = false) =>
  (dispatch) => {
    // console.log("-----------------------------",data)
    dispatch({
      type: SET_SCROLL_DIRECTION,
      payload: data,
    });
  };

export const SetPerPage = (data) => (dispatch) => {
  dispatch({
    type: SET_PER_PAGE,
    payload: data,
  });
};

export const SetCheckPage = (data) => (dispatch) => {
  // //console.log(data)
  dispatch({
    type: SET_CHECK_PAGE,
    payload: data,
  });
};

export const SetMessagePage = (data) => (dispatch) => {
  dispatch({
    type: SET_MESSAGE_PAGE,
    payload: data,
  });
};

export const SetGameCheck = (data) => (dispatch) => {
  dispatch({
    type: SET_GAMECHECK,
    payload: data,
  });
};

export const SetReconnectSetting = (data) => (dispatch) => {
  dispatch({
    type: SET_RECONNECT_SETTING,
    payload: data,
  });
};



// WEBPACK FOOTER //
// ./src/common/actions/pageAction.js